import { Outlet } from "react-router-dom";
import DashboardHeader from "../components/headers/DashboardHeader";
import SideNav from "../components/navigation/SideNav";
import DelegationsBanner from "../components/delegations/DelegationsBanner";
import MFAAnnouncementBanner from "../components/settings/MFAAnnouncementBanner";
import { useState } from "react";
import useIsMobile from "../utils/hooks/useIsMobile";

/**
 * Provides the common layout for all the dashboard
 * pages
 */
const DashboardLayout = () => {
  const isMobile = useIsMobile(768);
  const [compact, setCompact] = useState(false);

  return (
    <div
      className={
        "grid h-screen w-screen " +
        (isMobile || compact
          ? "grid-cols-[5rem_1fr]"
          : "grid-cols-[14.5rem_1fr]")
      }
    >
      {/* Top header */}
   

      {/* Lefthand Sidebar & Navigation links */}
      <SideNav
        className="h-screen"
        expanded={!(compact || isMobile)}
        toggleExpanded={() => setCompact(compact => !compact)}
      />
    <div className="grid grid-rows-[3.5rem_1fr] overflow-hidden">
       <DashboardHeader className="h-14 w-full" />
       <main id="dashboard-main-scroll" className="overflow-auto" style={{ backgroundColor: '#f4f4f4' }}>
        <MFAAnnouncementBanner />
        <DelegationsBanner />
        <Outlet />
      </main>
    </div>
      {/* Page content (provided via the Outlet component) */}
      
    </div>
  );
};

export default DashboardLayout;
